var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-new": false,
          "show-print": _vm.entity && !_vm.entity.isNew,
          "show-delete": _vm.entity && _vm.entity.active && !_vm.entity.isNew,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _vm.entity
              ? _c("otherlabour-side-menu", {
                  ref: "sideMenu",
                  attrs: { "entity-name": `${_vm.entity.itemNo}` },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            _vm.entity
              ? _c("router-view", {
                  key: _vm.$route.fullPath,
                  ref: "currentChild",
                  attrs: { "is-tiled": false, "route-name": _vm.$route.name },
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "unsaved-modal",
        {
          attrs: { active: _vm.isUnsavedModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isUnsavedModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            skipSave: function ($event) {
              return _vm.skipSave()
            },
            saveContinue: function ($event) {
              return _vm.saveContinue()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Unsaved Changes"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v("There are unsaved changes. Please select action below"),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }